import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useContext, useEffect, useState } from 'react';
import { UserType } from '../../types/types';
import { Container, DialogTitle, Divider, FormControlLabel, Grid, Paper, Switch, Typography } from '@mui/material';
import { UserContext } from '../../contexts/userContext';
import { useAddOrUpdateUser } from '../../hooks/users';
import { grey } from '@mui/material/colors';
import { IndicatorButton } from '../IndicatorButton';
export interface UsuarioDetailProps {
  usuario?: UserType;
  open: boolean;
  setOpen: (open:boolean) => void;
  onClose: () => void;
  refetchLista: () => void;
  lista: UserType[];
}

export default function UsuarioDetail(props:UsuarioDetailProps) {
  const { usuario, open, onClose, setOpen, refetchLista, lista } = props;
  const [ mutableUsuario, setMutableUsuario ] = useState<UserType | undefined>();
  const [estaEditando, setEstaEditando] = useState(!usuario);
  const { user } = useContext(UserContext);

  const permisos:UserType['roles'] = [
    'asistencia',
    'ver datos',
    'editar datos',
    'registrar pagos',
    'admin usuarios',
    'admin grupos',
    'admi cuotas',
    'ver alertas',
    'ver ingresos',
    'admin torneos',
  ];


  const usuarioApiCall = useAddOrUpdateUser(mutableUsuario, user);


  useEffect(() => {
    if (usuarioApiCall.data?._id && !usuarioApiCall.isFetching) {
      setTimeout(() => refetchLista(), 500);
    }
  }, [usuarioApiCall.data]);

  useEffect(() =>{
    setMutableUsuario(usuario);
    setEstaEditando(!usuario);
  }, [usuario]);

  let titulo = '';
  if (estaEditando && usuario) titulo = 'Editar usuario';
  if (estaEditando && !usuario) titulo = 'Crear Nuevo usuario';
  if (!estaEditando && usuario) titulo = 'Ver detalles de usuario';

  const validarUsername = (username?: string) => {
    if (!username || username.length === 0) return { valido: false, mensaje: 'El nombre de usuario no puede quedar vacio' };
    const usernameYaExiste = lista.filter((a) => a.username === mutableUsuario?.username).length > 0 && (estaEditando && !usuario);
    if (usernameYaExiste) return { valido: false, mensaje: 'Ya existe un usuario con este nombre' };
    return { valido: true, mensaje: '' };
  };

  const descartar = () => {
    setMutableUsuario(undefined);
    setOpen(false);
  };

  const handleSubmit = () => {
    usuarioApiCall.refetch();
    setEstaEditando(false);
    onClose();
  };

  return (
    <div>
      <Dialog open={open} onClose={estaEditando ? ()=>{} : onClose} closeAfterTransition >
        <DialogTitle>{titulo}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper elevation={3} style={{ padding: 8, marginTop: 16 }}>
                <Typography style={{ color: grey[800], fontSize: 14 }}>Permisos</Typography>
                <Divider />
                <Container   style={{ columns:'3 auto', width: 600 }} >
                  {permisos.map((permiso) => (
                    <FormControlLabel
                      // labelPlacement="start"
                      id={`control-label-${permiso}`}
                      control={<Switch
                        size='small'
                        id={`switch-${permiso}`}
                        color="primary"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          setMutableUsuario((prev) => {
                            const roles = JSON.parse(JSON.stringify(prev?.roles ?? []));
                            if (roles.includes(permiso) && !event.target.checked) {
                              roles.splice(roles.indexOf(permiso), 1);
                            }
                            if (!roles.includes(permiso) && event.target.checked) {
                              roles.push(permiso);
                            }
                            return ({ ...prev, roles });
                          });
                        }}
                      />}
                      disabled={!estaEditando}
                      checked={mutableUsuario?.roles?.includes(permiso)}
                      label={permiso}
                    />
                  ))}
                </Container>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                id="name"
                label="Nombre"
                type="text"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, firstName: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.firstName ?? ''}
                inputProps={{ readOnly: !estaEditando }}
                required
                error={!mutableUsuario?.firstName}
                helperText={!mutableUsuario?.firstName ? 'El Nombre no puede quedar vacio' : ''}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                id="apellido"
                label="Apellido"
                type="text"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, lastName: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.lastName ?? ''}
                inputProps={{ readOnly: !estaEditando }}
                required
                error={!mutableUsuario?.lastName}
                helperText="El Apellido no puede quedar vacio"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                id="username"
                label="Nombre de usuario"
                type="text"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, username: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.username ?? ''}
                inputProps={{ readOnly: !estaEditando }}
                required
                error={!validarUsername(mutableUsuario?.lastName).valido}
                helperText={validarUsername(mutableUsuario?.lastName).mensaje}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                id="email"
                label="Email"
                type="email"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, email: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.email ?? ''}
                inputProps={{ readOnly: !estaEditando }}
                required
                error={!mutableUsuario?.email}
                helperText="El email no puede quedar vacio"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {user?.roles?.includes('admin usuarios') && !estaEditando &&
          <>
            <Button
              variant="contained"
              onClick={() => setEstaEditando(true)}
            >
               Editar
            </Button>
            <Button
              variant="contained"
              onClick={onClose}
            >
                       Salir
            </Button>
          </>
          }
          {estaEditando &&
          <Button
            variant="contained"
            disabled={usuarioApiCall.isLoading}
            onClick={() =>{
              setEstaEditando(false);
              if (usuario) setMutableUsuario(usuario);
              else descartar();
            }}
          >
               Descartar
          </Button>}
          {estaEditando &&
          <IndicatorButton
            label='Guardar Cambios'
            disabled={
              !mutableUsuario?.username
              || !mutableUsuario.lastName
              || !mutableUsuario.firstName
              || !mutableUsuario.email
              || !validarUsername(mutableUsuario.username).valido
            }
            loading={usuarioApiCall.isLoading}
            onClick={handleSubmit}
          />}
        </DialogActions>
      </Dialog>
    </div>
  );
}
